import { z } from 'zod'

export const statusDto = z.object({
  globalStatus: z.string()
})

export const backVersionDto = z.object({
  version: z.string()
})
